import { makeRequest } from '../../../../lib/api';
import { CreateInsuranceDocRequestInterface, DeleteInsuranceDocRequestInterface } from '../../api/insuranceDocs';

const ORDER_INSURANCE_DOCS = '/v1/order_doc_type_statuses';

const insuranceDocsController = {
  getInsuranceDocs: (orderId: string): Promise<any> => {
    return makeRequest('get', `${ ORDER_INSURANCE_DOCS }?orderId=${ orderId }`);
    // return makeRequest('get', '/v1/ref_value/102');
  },

  createInsuranceDoc: (request: CreateInsuranceDocRequestInterface): Promise<any> => {
    return makeRequest('put', `${ ORDER_INSURANCE_DOCS }`, request);
  },

  deleteInsuranceDoc: (request: DeleteInsuranceDocRequestInterface): Promise<any> => {
    return makeRequest('delete', `${ ORDER_INSURANCE_DOCS }/${ request.orderDocTypeStatusId }`);
  },

  // deleteOrderExecutors: (id: string): Promise<any> => {
  //   return makeRequest('delete', `${ ORDER_EXECUTORS_PATH_V2 }/${ id }`);
  // },
};

export { insuranceDocsController };
